import repository from '@/utils/repository';

const common_resource = '/move';

export default {
    searchSystemInfo: (data) => {
        return repository.post(`${common_resource}/postCommonSystem001Info`, {
            ...data
        });
    }
};
